import React from "react";
import { styled, Container, Link, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Login } from "./Login";
import { IsIeWarning } from "./IsIeWarning";

import { Alert, AlertTitle } from "@material-ui/lab";
import WTWLogo from "../wtw_new_logo_color.svg";

const AreaContainer = styled("div")({
    margin: "1rem 0",
    display: "flex",
    justifyContent:'center'
});

const useStyles = makeStyles((theme) => ({
    link: {
        marginLeft: ".3rem",
        marginRight: ".3rem",
    },
}));

const Header = () => {
    return (
        <AreaContainer>
            <img alt="WTW Logo" style={{width:'50%'}} src={WTWLogo}></img>
        </AreaContainer>
    );
};

export const Home = () => {
    const styles = useStyles();
    return (
        <Container>
            <Grid container justify="center">
                <Grid item xs={12} sm={8}>
                    <Header />
                    <IsIeWarning />
                    <Login />
                </Grid>
            </Grid>
        </Container>
    );
};
